import React, { useEffect, useState, useRef } from 'react'
import { InputBox, FormButton, Switch, AutoCompleteBox, SelectInputBox } from "../commoncomponents/InputBox";

import { useAuth } from '../../context/auth';
import { Table } from '../commoncomponents/Table';

//loder
import BlurLoader from "../Loder/BlurLoader";

//react toast 
import { toast } from 'react-toastify';

//common Data
import { API_SERVER, handleDownloadExcel, initializeFilterData } from '../../Utils';

//services
import { post } from '../../apiservices/service';
import { number, Token } from '../Common/Common';

function DeductionMaster() {
    const inputrefs = useRef([]);
    const { user, sessionExpired } = useAuth();

    //token Data
    //const TokenData = {
    //    AuthToken: process.env.REACT_APP_SECRET_KEY,
    //    LoginToken: user.loginsessionID,
    //    UserID: user.userID,
    //    CompanyID: user.companyID
    //}
    const TokenData = Token()
    //initial state
    const [recipe, setRecipe] = useState({ DeductionID: "0", DeductionName: '', DeductionDisName: '', SequenceNo: '', DeductionType: '', Active: true })
    const [result, setResult] = useState({});
    const [loading, setLoading] = useState(false);
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [isUpdate, setIsUpdate] = useState(false);
    const [errors, setErrors] = useState({});


    const handleChange1 = (event, value) => {
        getFormData(value);
    };

    useEffect(() => {
        inputrefs.current['txtDeductionName'].focus();
        document.title = 'Viva HRMS : Deduction Master'
    }, [sortConfig])

    useEffect(() => {
        getFormData()
    }, [isUpdate])


    //Change Handler
    const HandleChange = (prop, value) => {
        setRecipe(recipe => ({ ...recipe, [prop]: value }))
    }

    //validation handler
    //const Validate = () => {
    //    if (recipe.DeductionName === "") {
    //        return ["Please Enter Deduction Name.! ", "txtDeductionName"]
    //    }
    //    else if (recipe.DeductionDisName === "") {
    //        return ["Please Enter Deduction Dis Name.! ", "txtDeductionDisName"]
    //    }
    //    else if (recipe.SequenceNo === "") {
    //        return ["Please Enter Sequence No.! ", "txtSequenceNo"]
    //    }
    //    else if (recipe.DeductionType === "") {
    //        return ["Please Select Deduction Type.! ", "txtDeductionType"]
    //    }
    //    else {
    //        return ""
    //    }
    //}

    const Validate = () => {
        setErrors({})
        let isValid = true;
        let validation = [
            { field: "DeductionName", msg: 'Please Enter Deduction Name.' },
            { field: "DeductionDisName", msg: 'Please Enter Deduction Display Name.' },
            { field: "SequenceNo", msg: 'Please Enter Sequence No.' },
            { field: "DeductionType", msg: 'Please Select Deduction Type.' },

        ]

        validation.map(item => {
            if (!recipe[item.field] || recipe[item.field].length <= 0 || recipe[item.field] === '') {

                setErrors(errors => ({ ...errors, [item.field]: item.msg }));
                isValid = false;
            }
            return item;
        });

        return isValid;
    }




    //Submit Handler
    const handleSubmit = () => {
        const myString = Validate();
        // if (myString === "") {
        if (Validate()) {
            setLoading(true)
            post(`${API_SERVER}api/MASTER/InsertUpdateDeductionMaster`, { ...TokenData, ...recipe }, (res) => {
                if (res && res.status) {
                    if (res.status === "ERROR") {
                        toast.error(res.message)
                        inputrefs.current[res.focus].focus();
                        setLoading(false)
                    } else if (res.Status === "EXPIRED") {
                        toast.error(res.Message)
                        sessionExpired()
                    } else if (res.Status === "UNAUTHORIZED") {
                        toast.error(res.Message);
                        setLoading(false);
                    } else {
                        setLoading(false)
                        toast.success(res.message)
                        handleClear()
                    }
                }
            });
        } else {
            // toast.error(myString[0])
            //       (inputrefs.current[myString[1]].focus())
        }
    }


    const getFormData = (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }

        setLoading(true)

        let temp = {
            PageIndex: PageIndex.toString(),
            SearchText: "",
            StartValue: "1",
            SearchFieldValue: "",
            Type: "s"
        }
        post(`${API_SERVER}api/MASTER/ShowDeductionMaster`, { ...TokenData, ...temp, ...sortConfig, ...filterData }, (res) => {
            if (res && res.Status) {
                if (res.Status === "ERROR") {
                    setLoading(false)
                    setResult({ ...res })
                } else if (res.Status === "EXPIRED") {
                    toast.error(res.Message)
                    sessionExpired()
                } else if (res.status === "UNAUTHORIZED") {
                    toast.error(res.message);
                    setLoading(false);
                } else {
                    setLoading(false)
                    setResult({ ...res })
                }
            }
        });
    }

    //Handle Edit
    const handleEdit = (Id) => {
        setLoading(true)
        post(`${API_SERVER}api/MASTER/EditDeductionMaster`, { ...TokenData, DeductionID: Id }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    toast.error(res.message)
                    setLoading(false)
                } else if (res.Status === "EXPIRED") {
                    toast.error(res.Message)
                    sessionExpired()
                } else if (res.status === "UNAUTHORIZED") {
                    toast.error(res.message);
                    setLoading(false);
                } else {
                    setLoading(false)
                    let data = res.data
                    setRecipe({
                        ...data, DeductionName: data.deductionName, DeductionDisName: data.deductionDisName,
                        DeductionType: data.deductionType, Active: data.active, SequenceNo: data.sequenceNo
                    })
                }
            }
        });
    }

    //Handle Delete
    const handleDelete = (Id) => {
        setLoading(true)
        post(`${API_SERVER}api/MASTER/DeleteDeductionMaster`, { ...TokenData, DeductionID: Id }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    toast.error(res.message)
                    setLoading(false)
                } else if (res.Status === "EXPIRED") {
                    toast.error(res.Message)
                    sessionExpired()
                } else if (res.status === "UNAUTHORIZED") {
                    toast.error(res.message);
                    setLoading(false);
                } else {
                    toast.success(res.message)
                    setLoading(false)
                    getFormData()
                    handleClear()
                }
            }
        });
    }

    //Reset Handler
    const handleClear = () => {
        setRecipe(recipe => ({ ...recipe, DeductionID: '0', DeductionName: '', DeductionDisName: '', SequenceNo: '', DeductionType: '', Active: true }))
        setErrors({})
        setFilterData(filterData => ({ ...filterData, SearchText: '' }))
        setIsUpdate(!isUpdate)
        getFormData()
        inputrefs.current['txtDeductionName'].focus();
    }

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';

        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
        getFormData()
    };

    //Start Export functionality
    let ExportRequest = {
        ...filterData,
        ...TokenData,
        ...sortConfig,
        Type: 'E',
        PageIndex: '1'
    }
    //End Export functionality

    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0">Deduction Master</h6>
                </div>
                <div className='card-body'>
                    <div className='row'>

                        <InputBox
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtDeductionDisName'].focus() };
                            }}
                            label='Deduction Name'
                            id='txtDeductionName'
                            maxLength='50'
                            placeholder="Deduction Name"
                            value={recipe.DeductionName}
                            onChange={(e) => HandleChange('DeductionName', e.target.value)}
                            required
                            error={errors.DeductionName}
                        />

                        <InputBox
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {inputrefs.current['txtSequenceNo'].focus()};
                            }}
                            label='Deduction Display Name'
                            id='txtDeductionDisName'
                            maxLength='50'
                            placeholder="Deduction Display Name"
                            value={recipe.DeductionDisName}
                            onChange={(e) => HandleChange('DeductionDisName', e.target.value)}
                            required
                            error={errors.DeductionDisName}
                        />
                        <InputBox
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtDeductionType'].focus() };
                            }}
                            label='Sequence No.'
                            id='txtSequenceNo'
                            maxLength='2'
                            placeholder="Sequence No."
                            value={recipe.SequenceNo}
                            onChange={(e) => { HandleChange('SequenceNo', number(e.target.value)) }}
                            required
                            error={errors.SequenceNo}
                        />
                        {/*<div className={`col-md-3 mb-1 cntrl-width`} key="txtDeductionType">*/}
                        {/*    <label className="form-label">Deduction Type <span style={{ color: "red" }}> *</span>*/}
                        {/*    </label>*/}
                        {/*    <select*/}
                        {/*        ref={ref => (inputrefs.current['txtDeductionType'] = ref)}*/}
                        {/*        className="form-control"*/}
                        {/*        id="txtDeductionType"*/}
                        {/*        value={recipe.DeductionType}*/}
                        {/*        onKeyDown={(e) => {*/}
                        {/*            if (e.key === 'Enter') { inputrefs.current['txtIsActive'].focus() };*/}
                        {/*        }}*/}
                        {/*        onChange={(e) => HandleChange('DeductionType', e.target.value)}>*/}
                        {/*        <option value="">-- Select Deduction Type--</option>*/}
                        {/*        <option value="On Attendance" >On Attendance</option>*/}
                        {/*        <option value="Monthly" >Monthly</option>*/}
                        {/*        <option value="Per Day">Per Day</option>*/}
                        {/*    </select>*/}
                        {/*    <div className="error-msg">{errors.DeductionType}</div>*/}
                        {/*</div>*/}
                        <SelectInputBox
                            label='Deduction Type'
                            inputrefs={inputrefs}
                            required
                            id="txtDeductionType"
                            value={recipe.DeductionType}
                            error={errors.DeductionType}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtIsActive'].focus() };
                            }}
                            onChange={(e) => HandleChange('DeductionType', e.target.value)}
                            children={<>
                                <option value="">-- Select Deduction Type--</option>
                                <option value="On Attendance" >On Attendance</option>
                                <option value="Monthly" >Monthly</option>
                                <option value="Per Day">Per Day</option>
                            </>}
                        />
                        <Switch
                            inputrefs={inputrefs}
                            label='Active'
                            checked={recipe.Active}
                            id='txtIsActive'
                            nextinputid='txtFranchiseGroup'
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { handleSubmit() };
                            }}
                            onChange={(e) => HandleChange('Active', e.target.checked)}
                        />

                        <FormButton
                            handleSubmit={handleSubmit}
                            handleExport={() => handleDownloadExcel(API_SERVER + 'api/MASTER/ShowDeductionMaster', ExportRequest, 'Deduction Master')}
                            handleClear={handleClear}
                        />
                    </div>
                </div>
            </div>

            {/* Table Component start*/}
            <Table
                Token={TokenData}
                PageName='DeductionMaster'
                handleEdit={handleEdit}
                handleDelete={handleDelete}
                handleFilter={() => {
                    getFormData();
                    setFilterData({
                        ...filterData,
                    });
                }}
                tableData={result}
                //  loading={loading}
                filterData={filterData}
                setFilterData={setFilterData}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
            />
            {/* Table Component End*/}


            {/* Loder start*/}
            {loading && < BlurLoader />}
            {/* Loder End*/}
        </>
    )
}

export default DeductionMaster